"use strict";
/**
 * @project-os/contracts
 *
 * Общие для backend и frontend перечисления, реестр типов ProjectItem
 * и контракты HTTP API. Пакет не зависит ни от NestJS, ни от React.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTACHMENT_LIMITS = void 0;
__exportStar(require("./enums"), exports);
__exportStar(require("./item-registry"), exports);
__exportStar(require("./api"), exports);
__exportStar(require("./dto"), exports);
__exportStar(require("./money"), exports);
__exportStar(require("./dates"), exports);
/** Ограничения вложений (документ «Технический план», §18.8). */
exports.ATTACHMENT_LIMITS = {
    /** 25 МБ на один файл. */
    maxBytes: 26_214_400,
    /**
     * Разрешённые MIME-типы. Исполняемые файлы запрещены; проверяется и MIME,
     * и расширение, и фактическая сигнатура файла.
     */
    allowedMimeTypes: [
        'image/png',
        'image/jpeg',
        'image/gif',
        'image/webp',
        'image/svg+xml',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.spreadsheet',
        'text/plain',
        'text/markdown',
        'text/csv',
        'application/json',
        'application/zip',
    ],
    allowedExtensions: [
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.webp',
        '.svg',
        '.pdf',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.ppt',
        '.pptx',
        '.odt',
        '.ods',
        '.txt',
        '.md',
        '.csv',
        '.json',
        '.zip',
    ],
};
//# sourceMappingURL=index.js.map